import {
  CsvFieldMapping,
  CsvImportField,
  mappedCsvValue,
} from "Components/Common/CsvImport/csvImportTypes";

export const MDA_IMPORT_FIELDS: CsvImportField[] = [
  { key: "Name", label: "Ministry / Department / Agency", required: true },
  { key: "Acronym", label: "Acronym" },
  { key: "Region", label: "Region", required: true },
  { key: "ParentMDA", label: "Parent MDA" },
  { key: "Description", label: "Description" },
  { key: "OldNid", label: "Old NID" },
  { key: "ParentOldNid", label: "Parent Old NID" },
];

export function mapMdaImportRow(
  row: Record<string, string>,
  mappings: CsvFieldMapping
) {
  const get = (key: string) => mappedCsvValue(row, mappings, key);
  return {
    name: get("Name"),
    acronym: get("Acronym"),
    region: get("Region"),
    parentMDA: get("ParentMDA"),
    description: get("Description"),
    oldNid: get("OldNid"),
    parentOldNid: get("ParentOldNid"),
  };
}
